"use client";

import { useQuery } from "@tanstack/react-query";

import { fetchNotice } from "@/services/analyze";

import { queryKeys } from "./query-key";

import type { AnalyzeFilter } from "@/types";

export const useNotice = (filter: AnalyzeFilter) => {
  return useQuery({
    queryKey: queryKeys.notice(filter),
    queryFn: () => fetchNotice(filter),
    enabled: !!filter.id,
  });
};
